import $ from "jquery";
import PubSub from "pubsub-js";

class ResponsiveComponentToggler {
    constructor() {
        this._startedElm = false;
        this._safeElmCopy = false;

        this._variationsDefault = {
            small: "horizontal",
            medium: "horizontal",
            large: "horizontal",
            xlarge: "horizontal",
            xxlarge: "horizontal",
        };
        this._variations = {};

        const responsiveComponentTogglers = $("*[data-responsive-component]");
        if (responsiveComponentTogglers.length) {
            responsiveComponentTogglers.each((index, el) => {
                this.init(el);
            });
        }
    }

    init(el) {
        this._startedElm = el;
        this._safeElmCopy = $(this._startedElm).clone();

        this._registerVariations();

        let oldSize = false;
        function responsiveCheck(scope) {
            let newSize = Foundation.MediaQuery.current;
            // console.log(newSize);

            let oldCompType = scope._getVariation(oldSize);
            let newCompType = scope._getVariation(newSize);

            if (oldCompType != newCompType) {
                // console.log(`${oldCompType} != ${newCompType}`);
                // console.log(`set the menu as ${newCompType}`);
                scope._setupMenu(newCompType);
            }

            oldSize = newSize;
        }
        responsiveCheck(this);

        $(window).on("changed.zf.mediaquery", (event) => {
            responsiveCheck(this);
        });
    }

    _setupMenu(menuType) {
        let thisComponent = $(this._safeElmCopy).clone();

        if (thisComponent.is(".is-started")) {
            thisComponent.foundation("_destroy").removeClass("is-started");
        }
        // console.log(thisComponent);
        // options:
        // • dropdown
        // • vertical
        // • horizontal
        // • tabs
        // • content-drilldown

        if (menuType == "dropdown") {
            thisComponent
                .addClass("dropdown c-special-menu--dropdown is-started")
                .attr("data-dropdown-menu", "")
                .foundation();
        } else if (menuType == "content-drilldown") {
            thisComponent
                .addClass("c-content-drilldown tabs vertical")
                .attr("data-tabs", "");
            thisComponent
                .children("li")
                .addClass("c-content-drilldown__title tabs-title");

            thisComponent.foundation().addClass("is-started");

            thisComponent.append(`
        <li class="c-content-drilldown__return">
          <button id="#return" class="button clear" onclick="window.location.replace(location.pathname);"><i class="icon-chevron-left"></i> ${translations.go_back}</button>
        </li>`);

            thisComponent.on("click", (event) => {
                /* event.preventDefault(); */
                /* returnToMenu(); */
            });

            returnToMenu();

            function returnToMenu() {
                thisComponent.removeClass("has-active");
                console.log(thisComponent);
                let tabContent = $(
                    `*[data-tabs-content="${thisComponent.attr("id")}"]`
                );
                tabContent
                    .children(".tabs-panel.is-active")
                    .removeClass("is-active");

                thisComponent.children(".is-active").removeClass("is-active");
            }

            thisComponent.on("change.zf.tabs", (event) => {
                if (thisComponent.children("li.is-active").length) {
                    thisComponent.addClass("has-active");
                }
            });
        } else if (menuType == "tabs") {
            thisComponent.addClass("tabs").attr("data-tabs", "");
            thisComponent.children("li").addClass("tabs-title");

            thisComponent.foundation().addClass("is-started");
            thisComponent.foundation(
                "_openTab",
                thisComponent.children("li").first()
            );
        } else if (menuType == "tabs-vertical") {
            thisComponent.addClass("c-tab-vertical tabs").attr("data-tabs", "");
            thisComponent
                .children("li")
                .addClass("c-tab-vertical__title tabs-title");

            thisComponent.foundation().addClass("is-started");
            thisComponent.foundation(
                "_openTab",
                thisComponent.children("li").first()
            );
        } else if (menuType == "vertical") {
        }

        $(this._startedElm).replaceWith(thisComponent);
        this._startedElm = thisComponent;
    }

    _getVariation(breakpoint) {
        let variation = false;

        Object.keys(this._variations).forEach((item) => {
            if (item == breakpoint) {
                variation = this._variations[item];
            }
        });

        return variation;
    }

    _registerVariations() {
        let userVariations = $(this._startedElm).data("responsive-component");

        let current = false;
        Object.keys(this._variationsDefault).forEach((item) => {
            let indexOfUserSetting = Object.keys(userVariations).indexOf(item);
            if (indexOfUserSetting > -1) {
                current = userVariations[item];
            } else {
                if (!current) {
                    current = this._variationsDefault[item];
                }
            }
            this._variations[item] = current;
        });

        // this._variations = $.extend({}, this._variationsDefault, userVariations);
        // console.log(this._variations);
    }
}

export default new ResponsiveComponentToggler();
